import Vue from "vue";
import VueRouter from "vue-router";
import { isLoggedIn } from "@/utils/auth";

Vue.use(VueRouter);

const routes = [
  {
    path: "/index",
    name: "index",
    component: () => import("@/views/homePage.vue"),
    meta: { title: "攀枝花东区社会工作协会-首页", name: "首页" },
  },
  {
    path: "/register/agreement",
    component: () => import("@/views/register/agreement.vue"),
    meta: { title: "攀枝花东区社会工作协会-注册", name: "注册" },
  },
  {
    path: "/register/personal",
    component: () => import("@/views/register/personal.vue"),
    meta: {
      title: "攀枝花东区社会工作协会-个人用户注册",
      name: "个人用户注册",
    },
  },
  {
    path: "/register/applyMembership",
    component: () => import("@/views/register/applyMembership.vue"),
    meta: { title: "攀枝花东区社会工作协会-个人用户注册", name: "申请入会" },
  },
  {
    path: "/register/enterprise",
    component: () => import("@/views/register/enterprise.vue"),
    meta: {
      title: "攀枝花东区社会工作协会-企业用户注册",
      name: "企业用户注册",
    },
  },
  {
    path: "/login",
    component: () => import("@/views/register/login/index.vue"),
    meta: { title: "攀枝花东区社会工作协会-登录", name: "登录" },
  },

  {
    path: "/aboutUs",
    name: "aboutUs",
    component: () => import("@/views/aboutUs.vue"),
    meta: { title: "攀枝花东区社会工作协会-关于我们", name: "关于我们" },
  },
  {
    path: "/associationNews",
    name: "associationNews",
    component: () => import("@/views/association/associationNews.vue"),
    meta: { title: "攀枝花东区社会工作协会-协会资讯", name: "协会资讯" },
    redirect: "/associationNews/notice",
    children: [
      {
        path: "notice",
        name: "associationNewsNotice",
        component: () =>
          import("@/views/association/components/associationNoticeList.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-协会资讯-协会通知",
          name: "协会通知",
        },
      },
      {
        path: "news",
        name: "associationNewsNews",
        component: () =>
          import("@/views/association/components/associationNewsList.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-协会资讯-协会要闻",
          name: "协会要闻",
        },
      },
      {
        path: "trainingNotice",
        name: "associationNewsTrainingNotice",
        component: () =>
          import("@/views/association/components/trainingNoticeList.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-协会资讯-培训通知",
          name: "培训通知",
        },
      },
      {
        path: "training",
        name: "associationNewsTraining",
        component: () => import("@/views/association/components/training.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-协会资讯-培训报名",
          name: "培训报名",
        },
      },
      {
        path: "industryTrends",
        name: "associationNewsIndustryTrends",
        component: () =>
          import("@/views/association/components/industryTrendsList.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-协会资讯-行业动态",
          name: "行业动态",
        },
      },
    ],
  },
  {
    path: "/associationNews/details",
    name: "associationNewsDetails",
    component: () => import("@/views/association/details.vue"),
    meta: { title: "攀枝花东区社会工作协会-协会资讯详情", name: "详情" },
  },
  {
    path: "/associationNews/courseDetails",
    name: "courseDetails",
    component: () => import("@/views/association/courseDetails.vue"),
    meta: {
      title: "攀枝花东区社会工作协会-培训报名详情",
      name: "培训报名详情",
    },
  },
  {
    path: "/memberCenter",
    name: "memberCenter",
    component: () => import("@/views/member/memberCenter.vue"),
    meta: { title: "攀枝花东区社会工作协会-会员中心", name: "会员中心" },
  },
  {
    path: "/memberService",
    name: "memberService",
    component: () => import("@/views/member/memberService.vue"),
    meta: { title: "攀枝花东区社会工作协会-会员服务", name: "会员服务" },
    redirect: "/memberService/memberShowcase",
    children: [
      {
        path: "memberShowcase",
        name: "memberServiceMemberShowcase",
        component: () => import("@/views/member/components/memberShowcase.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-会员服务-会员风采",
          name: "会员风采",
        },
      },
      {
        path: "recruitment",
        name: "memberServiceRecruitment",
        component: () => import("@/views/member/components/recruitment.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-会员服务-会员招聘",
          name: "会员招聘",
        },
      },
      {
        path: "memberNotice",
        name: "memberServiceMemberNotice",
        component: () => import("@/views/member/components/memberNotice.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-会员服务-会员通知",
          name: "会员通知",
        },
      },
    ],
  },
  {
    path: "/recruitmentDetails",
    name: "memberServiceRecruitmentDetails",
    component: () => import("@/views/member/recruitmentDetails.vue"),
    meta: {
      title: "攀枝花东区社会工作协会-会员服务-会员招聘详情",
      name: "会员招聘详情",
    },
  },
  {
    path: "/specialColumn",
    name: "specialColumn",
    component: () => import("@/views/specialColumn/specialColumn.vue"),
    meta: { title: "攀枝花东区社会工作协会-专题专栏", name: "专题专栏" },
    redirect: "/specialColumn/informationDisclosure",
    children: [
      {
        path: "informationDisclosure",
        name: "specialColumnInformationDisclosure",
        component: () =>
          import("@/views/specialColumn/components/informationDisclosure.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-专题专栏-信息公开",
          name: "信息公开",
        },
      },
      {
        path: "partyBuilding",
        name: "specialColumnPartyBuilding",
        component: () =>
          import("@/views/specialColumn/components/partyBuilding.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-专题专栏-党建引领",
          name: "党建引领",
        },
      },
      {
        path: "pilotProject",
        name: "specialColumnPilotProject",
        component: () =>
          import("@/views/specialColumn/components/pilotProject.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-专题专栏-试点项目",
          name: "试点项目",
        },
      },
      {
        path: "supervision",
        name: "specialColumnSupervision",
        component: () =>
          import("@/views/specialColumn/components/supervision.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-专题专栏-督导公告",
          name: "督导公告",
        },
      },
    ],
  },
  {
    path: "/resourceCenter",
    name: "resourceCenter",
    component: () => import("@/views/resource/resourceCenter.vue"),
    meta: { title: "攀枝花东区社会工作协会-资源中心", name: "资源中心" },
    redirect: "/resourceCenter/policyRegulations",
    children: [
      {
        path: "policyRegulations",
        name: "resourceCenterPolicyRegulations",
        component: () =>
          import("@/views/resource/components/policyRegulations.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-资源中心-政策法规",
          name: "政策法规",
        },
      },
      {
        path: "variousForms",
        name: "resourceCenterVariousForms",
        component: () => import("@/views/resource/components/variousForms.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-资源中心-各类表格",
          name: "各类表格",
        },
      },
      {
        path: "visitForms",
        name: "resourceCenterVisitForms",
        component: () => import("@/views/resource/components/visitForms.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-资源中心-参观预约表格",
          name: "参观预约表格",
        },
      },
    ],
  },
  {
    path: "/resourceCenter/details",
    name: "resourceCenterDetails",
    component: () => import("@/views/resource/details.vue"),
    meta: { title: "攀枝花东区社会工作协会-资源中心详情", name: "详情" },
  },
  {
    path: "/adviceForHelp",
    name: "adviceForHelp",
    component: () => import("@/views/adviceForHelp/adviceForHelp.vue"),
    meta: { title: "攀枝花东区社会工作协会-求助建议", name: "求助建议" },
  },
  {
    path: "/adviceForHelp",
    name: "adviceForHelp",
    component: () => import("@/views/adviceForHelp/adviceForHelp.vue"),
    meta: { title: "攀枝花东区社会工作协会-求助建议", name: "求助建议" },
  },
  {
    path: "/personalCenter",
    name: "personalCenter",
    component: () => import("@/views/personalCenter/home.vue"),
    meta: { title: "攀枝花东区社会工作协会-个人中心", name: "个人中心" },
    redirect: "/personalCenter/index",
    children: [
      {
        path: "index",
        name: "personalCenterIndex",
        component: () => import("@/views/personalCenter/index.vue"),
        meta: { title: "攀枝花东区社会工作协会-个人中心-首页", name: "首页" },
      },
      {
        path: "userCenter/log",
        name: "userCenterLog",
        component: () => import("@/views/personalCenter/userCenter/log.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-个人中心-日志信息",
          name: "日志信息",
        },
      },
      {
        path: "userCenter/info",
        name: "userCenterInfo",
        component: () => import("@/views/personalCenter/userCenter/info.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-个人中心-修改用户信息",
          name: "修改用户信息",
        },
      },
      {
        path: "userCenter/phone",
        name: "userCenterPhone",
        component: () => import("@/views/personalCenter/userCenter/phone.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-个人中心-修改手机号码",
          name: "修改手机号码",
        },
      },
      {
        path: "userCenter/email",
        name: "userCenterEmail",
        component: () => import("@/views/personalCenter/userCenter/email.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-个人中心-修改邮箱",
          name: "修改邮箱",
        },
      },
      {
        path: "userCenter/password",
        name: "userCenterPassword",
        component: () =>
          import("@/views/personalCenter/userCenter/password.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-个人中心-修改密码",
          name: "修改密码",
        },
      },
      {
        path: "memberManagement/membership",
        name: "memberManagementMembership",
        component: () =>
          import("@/views/personalCenter/memberManagement/membership.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-个人中心-入会申请",
          name: "入会申请",
        },
      },
      {
        path: "memberManagement/withdrawal",
        name: "memberManagementWithdrawal",
        component: () =>
          import("@/views/personalCenter/memberManagement/withdrawal.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-个人中心-退会申请",
          name: "退会申请",
        },
      },
      {
        path: "trainingSystem/registration",
        name: "trainingSystemRegistration",
        component: () =>
          import("@/views/personalCenter/trainingSystem/registration.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-个人中心-培训报名",
          name: "培训报名",
        },
      },
      {
        path: "trainingSystem/cart",
        name: "trainingSystemCart",
        component: () =>
          import("@/views/personalCenter/trainingSystem/cart.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-个人中心-购物车",
          name: "课程表",
        },
      },
      {
        path: "trainingSystem/order",
        name: "trainingSystemOrder",
        component: () =>
          import("@/views/personalCenter/trainingSystem/order.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-个人中心-课程订单",
          name: "课程订单",
        },
      },
      {
        path: "trainingSystem/my",
        name: "trainingSystemMy",
        component: () => import("@/views/personalCenter/trainingSystem/my.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-个人中心-我的课程",
          name: "我的课程",
        },
      },
      {
        path: "trainingSystem/progress/offline",
        name: "trainingSystemProgressOffline",
        component: () =>
          import("@/views/personalCenter/trainingSystem/progress/offline.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-个人中心-面授学习进度",
          name: "面授学习进度",
        },
      },
      {
        path: "trainingSystem/progress/online",
        name: "trainingSystemProgressOnline",
        component: () =>
          import("@/views/personalCenter/trainingSystem/progress/online.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-个人中心-网络学习进度",
          name: "网络学习进度",
        },
      },
      {
        path: "trainingSystem/clockIn",
        name: "trainingSystemClockIn",
        component: () =>
          import("@/views/personalCenter/trainingSystem/clockIn.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-个人中心-签到打卡",
          name: "签到打卡",
        },
      },
      {
        path: "trainingSystem/grade",
        name: "trainingSystemGrade",
        component: () =>
          import("@/views/personalCenter/trainingSystem/grade.vue"),
        meta: {
          title: "攀枝花东区社会工作协会-个人中心-成绩查询",
          name: "成绩查询",
        },
      },
    ],
  },
  {
    path: "/personalCenter/trainingSystem/onlineStudyDetails",
    name: "trainingSystemOnlineStudyDetails",
    component: () =>
      import("@/views/personalCenter/trainingSystem/onlineStudyDetails.vue"),
    meta: {
      title: "攀枝花东区社会工作协会-个人中心-在线学习详情",
      name: "在线学习详情",
    },
  },
];

const router = new VueRouter({
  mode: "history", // 去掉 URL 中的 # 号
  // base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }; // 切换路由时滚动到顶部
  },
});

// 路由守卫 - 设置页面标题
router.beforeEach((to, from, next) => {
  if (to.path == "/") {
    router.replace("/index");
  }
  document.title = to.meta.title || "官网";

  // 检查是否访问个人中心相关页面
  if (to.path.includes("personalCenter")) {
    // 如果未登录，跳转到登录页面
    if (!isLoggedIn()) {
      next({
        path: "/login",
        query: { redirect: to.fullPath },
      });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
